import React from "react";
import "./ChatBubble.css";

export default function ChatBubble({ texto, tipo, hora }) {
  const isAdmin = tipo === "admin";

  return (
    <div className={`bubble-container ${isAdmin ? "admin" : "user"}`}>
      <div className="bubble">
        <p className="bubble-text">{texto}</p>

        {hora && <span className="bubble-time">{hora}</span>}
      </div>
    </div>
  );
}
